import "slick-slider";
import {WPApi} from "../common/wp-api";
import {share} from "../article/social";
import "attrchange";
import "../common/jquery-functions";

const api = new WPApi();

const vodSlidersContent = {};

const vodSlickOptions = {
    centerMode: true,
    rtl: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    // infinite: false,
    // initialSlide: 1,
    draggable: false,
    arrows: true,
    variableWidth: true,
    nextArrow: "<div class='slider-arrow slider-arrow-left'><img src='/app/themes/sport1/public/images/left-arrow.svg' alt=''></div>",
    prevArrow: "<div class='slider-arrow slider-arrow-right'><img src='/app/themes/sport1/public/images/right-arrow.svg' alt=''></div>",
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
                centerMode: false,
                variableWidth: false
            }
        }
    ]
};

jQuery(document).ready(($) => {

    vodSlidersContent['most_viewed'] = $('.home-vod-content .home-vod-slider').html();

    const $slider = $('.home-vod-slider');

    $slider.slick(vodSlickOptions);


    $slider.on('beforeChange', function (e, slick, currentSlide, nextSlide) {

        // next
        let direction = 1;

        // prev
        if ((currentSlide > nextSlide && (nextSlide !== 0 || currentSlide === 1)) || (currentSlide === 0 && nextSlide === slick.slideCount - 1)) {
            direction = -1;
        }

        addSlidesClassForDirection(direction);

    });

    $slider.on('afterChange', function (e, slick, currentSlide, nextSlide) {
        // $('.home-vod-slider .slick-slide.slick-center.slick-current').removeClass('slide-next').removeClass('slide-prev');
        $('.home-vod-slider .slick-slide').css('transition-duration', '0s');
        addSlidesClassForDirection();
        setTimeout(() => {
            $('.home-vod-slider .slick-slide').css('transition-duration', '0.3s');
        }, 300);
    });

    addSlidesClassForDirection();

    lazyLoader.update($slider);

    const $vodNavItems = $('.homepage-vod-navbar-item:not(.sub-nav-item)');

    $vodNavItems.on('click', async function () {
        const $this = $(this);

        sport1Analytics.sendEvent('desktop-home-page', 'vod-tab-click', $this.text())

        if (!$this.hasClass('active')) {

            // add active classes to clicked nav item
            // and remove current active
            $('.homepage-vod-navbar-item.active').removeClass('active selected');

            $('.homepage-vod-navbar-items').addClass('nav-open');
            $('.homepage-vod-navbar-item:not(.sub-nav-item)').not($this).addClass('nav-hidden');

            const $categoriesContainer = $this.next('.sub-categories');
            $this.addClass('active selected');
            $('.homepage-vod-navbar-item', $categoriesContainer).fadeIn();
            $categoriesContainer.addClass('active');
            $categoriesContainer.css('justify-content', 'flex-start');
            $this.prepend('<span class="close-nav"></span>');


            $slider.fadeOut();

            const categoryId = $this.data('category');

            await loadCategorySlider(categoryId);

            /**
             * refresh slider with new content
             * */
            $slider.slick('unslick');
            $slider.html(vodSlidersContent[categoryId]);
            $slider.slick(vodSlickOptions);
            addSlidesClassForDirection();
            lazyLoader.update($slider);

            $slider.fadeIn();

        }

    });

    const $vodSection = $('.homepage-section-vod');

    /**
     * close vod nav click
     * */
    $vodSection.on('click', '.close-nav', function () {
        $('.homepage-vod-navbar-items').removeClass('nav-open');
        // all nav items
        const $navItems = $('.homepage-vod-navbar-item');
        // hot excerpts nav item
        const $hotExcerptsNavItem = $navItems.first();
        // close icon clicked
        const $closeCurrentNavButton = $(this);
        // nav item to close -> close button parent
        const $navItemToClose = $closeCurrentNavButton.parent();
        // sub categories nav to hide
        const $subCategories = $navItemToClose.next('.sub-categories');

        // remove active classes from current open nav item
        $('.homepage-vod-navbar-item.active').removeClass('active selected');

        // add active classes to hot excerpts nav item
        $hotExcerptsNavItem.addClass('active selected');

        // fade out vod slider
        $slider.fadeOut();

        $navItems.removeClass('nav-hidden');

        // remove active class from sub categories
        $subCategories.removeClass('active');

        // get category id for hot excerpts
        const categoryId = $hotExcerptsNavItem.data('category');

        /**
         * refresh slider
         * */
        $slider.slick('unslick');
        $slider.html(vodSlidersContent[categoryId]);
        $slider.slick(vodSlickOptions);
        addSlidesClassForDirection();

        // refresh images lazy loader
        lazyLoader.update($slider);

        // show slider again
        $slider.fadeIn();

        // show previously hidden main nav items
        $navItems.fadeIn();

        // remove previously attached close button
        $closeCurrentNavButton.detach();


    });


    $vodSection.on('click', '.sub-nav-item', async function () {
        const $this = $(this);
        const categoryId = $this.attr('data-category');

        sport1Analytics.sendEvent('desktop-home-page', 'vod-tab-click', $this.text())

        $('.sub-nav-item.active-sub-item').removeClass('active-sub-item');

        $this.addClass('active-sub-item');

        $slider.fadeOut();
        await loadCategorySlider(categoryId);

        /**
         * refresh slider with new content
         * */
        $slider.slick('unslick');
        $slider.html(vodSlidersContent[categoryId]);
        $slider.slick(vodSlickOptions);
        addSlidesClassForDirection();
        lazyLoader.update($slider);
        $slider.fadeIn();

    });

    $('.sub-categories .nav').click(function () {
        const $subCategories = $(this).parent();
        let scrollBy = -300;
        if ($(this).hasClass('nav-prev')) {
            scrollBy *= -1;
        }

        $subCategories[0].scrollBy({left: scrollBy, behavior: 'smooth'})
    });

    $('.sub-categories').on('scroll', function () {
        let left = $(this).width() - (this.scrollWidth - this.scrollLeft);

        $('.nav-prev', $(this)).css('right', `${Math.abs(left)}px`);
        $('.nav-next', $(this)).css('left', `${left}px`);


        let scrollLeft = $(this).scrollLeft();
        let width = $(this).width();

        if (scrollLeft + width < this.scrollWidth) {
            $('.nav-prev', $(this)).addClass('active');
        } else {
            $('.nav-prev', $(this)).removeClass('active');
        }

        if (scrollLeft === 0) {
            $('.nav-next', $(this)).removeClass('active');
        } else {
            $('.next', $(this)).addClass('active');
        }
    });

    $('body').on('click', '.home-vod-slider-item .social-icon', function () {
        const sliderItem = $(this).closest('.home-vod-slider-item');
        let link = window.location.host + $('.post-link', sliderItem).attr('href');
        let medium = $(this).attr('id');
        sport1Analytics.sendEvent('desktop-home-page', 'share-vod-click', medium);
        share(link, medium);
    });


    $('.home-vod-slider-item a.post-link').on('click', function () {
        let $this = $(this).closest('.home-vod-slider-item');
        let label = $('.home-vod-slider-item-title a', $this).text();
        sport1Analytics.sendEvent('desktop-home-page', 'vod-play', label);
    });

    $('.home-vod-slider .view-all a').on('click', function () {
        let label = 'all vods'
        sport1Analytics.sendEvent('desktop-home-page', 'all-vods-click', label);
    });

});

function addSlidesClassForDirection(direction = Number.MAX_SAFE_INTEGER) {

    // current center slide
    const $centerSlide = $('.slick-center.slick-current');
    let centerSlideIndex = parseInt($centerSlide.data('slick-index'));
    let originalCenterSlideIndex = centerSlideIndex;

    // if moving backwards (-1), center slide index
    // is 1 less then actual index (this is called before the change)
    if (direction !== Number.MAX_SAFE_INTEGER) {
        if (direction === -1) {
            centerSlideIndex--;
        } else if (direction === 1) {
            centerSlideIndex++;
        }
    }

    $('.home-vod-slider .slick-slide').each(function () {
        const $this = $(this);
        let thisIndex = parseInt($this.data('slick-index'));

        if (originalCenterSlideIndex === thisIndex) {
            if (direction === -1) {
                $this.addClass('slide-next').removeClass('slide-prev');
            } else if (direction === 1) {
                $this.addClass('slide-prev').removeClass('slide-next');
            }
        } else {
            if (thisIndex < centerSlideIndex) {
                $this.addClass('slide-prev').removeClass('slide-next');
            } else if (thisIndex > centerSlideIndex) {
                $this.addClass('slide-next').removeClass('slide-prev');
            }
        }
    });

    $(`.home-vod-slider .slick-slide[data-slick-index=centerSlideIndex]`).removeClass('slide-prev slide-next');
    // $centerSlide.prev().addClass('slide-prev').removeClass('slide-next');
    // $centerSlide.next().addClass('slide-next').removeClass('slide-prev');
}

async function loadCategorySlider(categoryId) {

    let content = vodSlidersContent[categoryId];
    if (!content) {
        content = await api.get(`sport1/v1/home/vod/${categoryId}/videos`);
        vodSlidersContent[categoryId] = content;
    }

    return content;
}